import { render, staticRenderFns } from "./list_suppliers_component.vue?vue&type=template&id=5519ece8&scoped=true"
import script from "./list_suppliers_component.vue?vue&type=script&lang=js"
export * from "./list_suppliers_component.vue?vue&type=script&lang=js"
import style0 from "./list_suppliers_component.vue?vue&type=style&index=0&id=5519ece8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519ece8",
  null
  
)

export default component.exports